import api from 'api'

export type UpdateCushionChargePolicyRequest = {
  companyId: number
  policyId: number
  chargeAfterMinutes: number
}

export const updateCushionChargePolicy = async ({
  companyId,
  policyId,
  chargeAfterMinutes,
}: UpdateCushionChargePolicyRequest): Promise<void> => {
  await api.patch(
    `/admin/company/${companyId}/cushion_charge_policies/${policyId}`,
    { chargeAfterMinutes }
  )
}
